import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _NationalizationProcessItems } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { InputMoney } from "../../../../../theme/Input/InputMoney";


interface Props {
    IDNationalizationProcessGeneralInfo: number;
}


export const NationalizationProcessItemsByLiquidation = ({ IDNationalizationProcessGeneralInfo }: Props) => {

    const ByLiquidation = useDataBean(_NationalizationProcessItems);
    const single = Singleton.getInstance();
    const [Type, setType] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDNationalizationProcessGeneralInfo])

    const getLista = () => {

        ByLiquidation.instance.getNationalizationProcessItemsRender( IDNationalizationProcessGeneralInfo).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        ByLiquidation.setBean({
            IDNationalizationProcessGeneralInfo: IDNationalizationProcessGeneralInfo,
            ItemType: ByLiquidation.bean.ItemType,
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ByLiquidation.deleteItemVoid(ByLiquidation.bean.IDNationalizationProcessItems).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }


    const editaItem = () => {
        //console.log(entailment.bean);
        ByLiquidation.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDNationalizationProcessItems', visible: true },
        // { title: 'Tipo de  Item / Lote', property: 'ItemType', visible: true },
        // { title: 'Consecutivo de registro', property: 'Item', visible: true },
        { title: 'Lote', property: 'LoteNumber', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        // { title: 'Total Valor FOB USD', property: 'TotalValueFobLC', visible: true, mask: MASK_MONEY },
        // { title: 'Fletes y Seguros', property: 'GrandTotalTransportaitionInsuranceLC', visible: true },
        // { title: 'Valor Total CIP USD', property: 'TotalValueCipLC', visible: true },
        { title: 'Otros Costos USD', property: 'OtherCostsLC', visible: true, mask: MASK_MONEY },
        // { title: 'Valor total USD', property: 'TotalDapValueLC', visible: true },
        // { title: 'Valor total en Pesos', property: 'DapValueTotalCOPLC', visible: true },
        // { title: 'Valor Gravamenes', property: 'TaxValueLC', visible: true, mask: MASK_MONEY },
        // { title: 'Comision Forpo', property: 'ForpoComissionLC', visible: true },
        // { title: 'Valor Total en Pesos', property: 'TotaValueCOPLC', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "name": `Editar ${ByLiquidation.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        // <BasicPage titulo="Items">
            <div className="row">
                {/* <div className="col-md-6">
                    <label>Tipo de  Item / Lote</label>
                    <SelectTHConstantsValue code={602} value={Type} onChange={(e: any) => { setType(e) }}></SelectTHConstantsValue>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar por Item / Lote</BasicButton>
                </div> */}
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ByLiquidation.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            {/* <div className="col-md-12">
                                <label>Tipo de  Item / Lote</label>
                                <SelectTHConstantsValue code={602} value={ByLiquidation.bean.ItemType} onChange={(e: any) => { ByLiquidation.setBean({ ...ByLiquidation.bean, "ItemType": e }) }}></SelectTHConstantsValue>
                            </div> */}
                            {/* <div className="col-md-6">

                                <label>No.Consecutivo de registro item</label>
                                <input type="text" name="Item" className="form-control" value={ByLiquidation.bean.Item} onChange={ByLiquidation.handleChange} />

                            </div> */}
                            {/* <div className="col-md-6">

                                <label>No. Lote</label>
                                <input type="text" name="LoteNumber" className="form-control" value={ByLiquidation.bean.LoteNumber} onChange={ByLiquidation.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Cantidad</label>
                                <input type="text" name="Quantity" className="form-control" value={ByLiquidation.bean.Quantity} onChange={ByLiquidation.handleChange} />

                            </div> */}

                            {/* <div className="col-md-6">

                                <label>Total Valor FOB USD</label>
                                <input type="text" name="TotalValueFobLC" className="form-control" value={ByLiquidation.bean.TotalValueFobLC} onChange={ByLiquidation.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Fletes y Seguros</label>
                                <input type="text" name="GrandTotalTransportaitionInsuranceLC" className="form-control" value={ByLiquidation.bean.GrandTotalTransportaitionInsuranceLC} onChange={ByLiquidation.handleChange} />

                            </div> */}

                            {/* <div className="col-md-6">

                                <label>Valor Total Cip USD</label>
                                <input type="text" name="TotalValueCipLC" className="form-control" value={ByLiquidation.bean.TotalValueCipLC} onChange={ByLiquidation.handleChange} />

                            </div> */}
                            <div className="col-md-12">

                                <InputMoney _label="Otros Costos USD" _value={ByLiquidation.bean.OtherCostsLC}  onChange={(e: any) => { ByLiquidation.setBean({ ...ByLiquidation.bean, "OtherCostsLC": e }) }} />
                                {/* <label>Otros Costos</label>
                                <input type="text" name="OtherCostsLC" className="form-control" value={ByLiquidation.bean.OtherCostsLC} onChange={ByLiquidation.handleChange} /> */}

                            </div>
                            {/* <div className="col-md-6">

                                <label>Valor Total USD</label>
                                <input type="text" name="TotalDapValueLC" className="form-control" value={ByLiquidation.bean.TotalDapValueLC} onChange={ByLiquidation.handleChange} />

                            </div>

                            <div className="col-md-6">

                                <label>Valor Total Pesos</label>
                                <input type="text" name="DapValueTotalCOPLC" className="form-control" value={ByLiquidation.bean.DapValueTotalCOPLC} onChange={ByLiquidation.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Valor Gravamenes</label>
                                <input type="text" name="TaxValueLC" className="form-control" value={ByLiquidation.bean.TaxValueLC} onChange={ByLiquidation.handleChange} />

                            </div> */}
                            {/* <div className="col-md-6">

                                <label>% Arancel</label>
                                <TaxPositionEditor render={ByLiquidation.bean.TaxCode} idSelector={ByLiquidation.bean.IDTaxPosition} onChange={(e) => { ByLiquidation.setBean({ ...ByLiquidation.bean, "IDTaxPosition": e.IDTaxPosition, "TaxCode": e.TaxCode }) }} label=" " returnType="Object" />
                            </div> */}
                            {/* <div className="col-md-6">
                                <label>Tasa de Cambio</label>
                                <input type="text" name="ExchangeRateLC" className="form-control" value={ByLiquidation.bean.ExchangeRateLC} onChange={ByLiquidation.handleChange} />
                            </div> */}
                            {/* <div className="col-md-6">

                                <label>Comision Forpo</label>
                                <input type="text" name="ForpoComissionLC" className="form-control" value={ByLiquidation.bean.ForpoComissionLC} onChange={ByLiquidation.handleChange} />

                            </div> */}
                            {/* <div className="col-md-6">

                                <label>Valor Total en Pesos</label>
                                <input type="text" name="TotaValueCOPLC" className="form-control" value={ByLiquidation.bean.TotaValueCOPLC} onChange={ByLiquidation.handleChange} />

                            </div> */}
                            {/* <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={ByLiquidation.bean.Description} onChange={ByLiquidation.handleChange} />
                            </div> */}
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ByLiquidation.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        // </BasicPage>
    )
}